import { AppBar, UserMenu } from "react-admin";
import { Box, Typography } from "@mui/material";

const MyAppBar = (props) => (
  <AppBar {...props} title={undefined} userMenu={false}>
    {/* LEFT: SSDN */}
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography
        variant="h6"
        sx={{ ml: 1, fontWeight: 600, whiteSpace: "nowrap" }}
      >
        MYLEARN ADMIN PORTAL
      </Typography>
    </Box>

    {/* CENTER: LOGO */}
    <Box
      sx={{
        position: "absolute",
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box
        component="img"
        src="https://www.ssdntech.com/assets/images/logo.webp"
        alt="SSDN Logo"
        sx={{ height: 40, borderRadius: 2 }}
      />
    </Box>

    {/* RIGHT: default user menu / other icons */}
    <Box sx={{ marginLeft: "auto" }}>
      <UserMenu />
    </Box>
  </AppBar>
);

export default MyAppBar;
